import { Text, HStack, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'

import { IconTextProps } from '../../types'

function IconText({ text, image }: IconTextProps): React.ReactElement {
  return (
    <HStack
      spacing={{ base: 4, sm: 6 }}
      sx={{ alignItems: { base: 'center', sm: 'flex-start', md: 'center' } }}
    >
      <AspectRatio ratio={1} sx={{ w: '15' }}>
        <Image src={image} alt="" layout="fill" />
      </AspectRatio>
      <Text
        sx={{
          fontSize: { base: 'md', sm: 'lg' },
          flex: '1 1 auto',
          w: 'full',
        }}
      >
        {text}
      </Text>
    </HStack>
  )
}

export default IconText
